// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuItem_root__N_0BZ","active":"MenuItem_active__Lmgut","box":"MenuItem_box__LFOJ7","content":"MenuItem_content__gvtXk","icon":"MenuItem_icon__Pm1Qi"};